import { init, track, setUserId } from '@amplitude/analytics-browser'
import getEnvironment, {
  ENVIRONMENTS,
  isAnalyticsEnabledHost,
} from './helpers/environment'

// Constants for user properties and events
export const CHANNEL_NAME = 'Resident Portal Website'
const USER_ID = 'user_id'
const NAME_FIRST = 'first_name'
const NAME_LAST = 'last_name'
const EMAIL = 'email'
const ADDRESS = 'street_address'
const CITY = 'city'
const STATE = 'state'
const ZIP = 'zip_code'
const PHONE = 'phone'
const PROPERTY_ID = 'property_id'
const PROPERTY_NAME = 'property_name'
const LEAD_SOURCE = 'source'
const CHANNEL = 'channel'
const PERSONAL_CONTENTS_AMOUNT = 'personal_contents_amount'
const LIABILITY_LIMIIT = 'liability_amount'
const DEDUCTIBLE = 'deductible'
const PREMIUM_AMOUNT = 'premium_amount'
const BILLING_FREQUENCY = 'billing_frequency'
const COVERAGE_BENEFITS = 'coverage_benefits'
const CONTRACTED_PROPERTY_SELECTED = 'contracted_property_selected'
const COVERAGE_START_DATE = 'coverage_start_date'
const PAYMENT_METHOD = 'payment_method'
const CARD_TYPE = 'card_type'
const ALERT_TYPE = 'alert_type'
const QUOTE_REASON = 'quote_reason'
const ADD_POLICY = 'add_policy'
const ID_THEFT_INDIVIDUAL_CHECKED = 'id_theft_individual_checked'
const ID_THEFT_FAMILY_CHECKED = 'id_theft_family_checked'
const ENROLLMENT_TYPE = 'enrollment_type'
const ENROLLMENT_CHANNEL = 'enrollment_channel'
const THIRD_PARTY_POLICY_PROVIDER = 'third_party_policy_provider'
const THIRD_PARTY_POLICY_LIABILITY_AMOUNT =
  'third_party_policy_liability_amount'
const THIRD_PARTY_POLICY_PERSONAL_CONTENT_AMOUNT =
  'third_party_policy_personal_content_amount'
const THIRD_PARTY_POLICY_DEDUCTIBLE = 'third_party_policy_deductible'
const THIRD_PARTY_POLICY_DATE_COVERAGE_BEGINES =
  'third_party_policy_date_coverage_begins'
const THIRD_PARTY_POLICY_DATE_COVERAGE_END =
  'third_party_policy_date_coverage_ends'

export const properties = {
  USER_ID,
  NAME_FIRST,
  NAME_LAST,
  EMAIL,
  ADDRESS,
  CITY,
  STATE,
  ZIP,
  PHONE,
  PROPERTY_ID,
  PROPERTY_NAME,
  LEAD_SOURCE,
  CHANNEL,
  PERSONAL_CONTENTS_AMOUNT,
  LIABILITY_LIMIIT,
  DEDUCTIBLE,
  PREMIUM_AMOUNT,
  BILLING_FREQUENCY,
  COVERAGE_BENEFITS,
  CONTRACTED_PROPERTY_SELECTED,
  COVERAGE_START_DATE,
  PAYMENT_METHOD,
  CARD_TYPE,
  ALERT_TYPE,
  QUOTE_REASON,
  ADD_POLICY,
  ID_THEFT_INDIVIDUAL_CHECKED,
  ID_THEFT_FAMILY_CHECKED,
  ENROLLMENT_TYPE,
  ENROLLMENT_CHANNEL,
  THIRD_PARTY_POLICY_PROVIDER,
  THIRD_PARTY_POLICY_LIABILITY_AMOUNT,
  THIRD_PARTY_POLICY_PERSONAL_CONTENT_AMOUNT,
  THIRD_PARTY_POLICY_DEDUCTIBLE,
  THIRD_PARTY_POLICY_DATE_COVERAGE_BEGINES,
  THIRD_PARTY_POLICY_DATE_COVERAGE_END,
}

const EMAIL_ENTERED = 'Email Entered'
const CUSTOMER_INFO_ENTERED = 'Customer Info Entered'
const ENROLLMENT_CONFIRMED = 'Enrollment Confirmed'
const ENROLLMENT_SUBMITTED = 'Enrollment Submitted'
const QUOTE_STARTED = 'Quote Started'
const ENROLL_BUTTON_CLICKED = 'Enroll Button Clicked'
const QUOTE_VIEWED = 'Quote Viewed'
const PROPERTY_SELECTED = 'Property Selected'
const COVERAGE_START_DATE_SELECTED = 'Coverage Start Date Selected'
const ADD_ADDITIONAL_INSURED_CLICKED = 'Add Additional Insured Clicked'
const ADD_INSURED_SAVED = 'Add Insured Saved'
const ADD_INSURED_CANCEL = 'Add Insured Cancel'
const CHANGE_COVERAGE_SAVE = 'Change Coverage Save'
const CHANGE_COVERAGE_CANCEL = 'Change Coverage Cancel'
const CHANGE_COVERAGE_BACK = ' Change Coverage Back'
const EASY_ENROLL_BACK = 'Easy Enroll Back'
const BACK_BROWSER = 'Back Browser'
const SELECT_PAYMENT_METHOD_CLICKED = 'Select Payment Method Clicked'
const ADD_INSURED = 'Add Insured'
const PAYMENT_ENTERED = 'Payment Entered'
const EDIT_POLICY = 'Edit Policy'
const COMPLETE_ENROLLMENT = 'Complete Enrollment'
const TIMEOUT_TRIGGERED = 'Timeout Triggered'
const EXISTING_EMAIL_ENTERED = 'Existing Email Entered'
const PAGE_NOT_FOUND = 'Page Not Found'
const ADD_OWN_POLICY = 'Add Own Policy'
const EXISTING_POLICY_ADDED = 'Existing Policy Added'
const CREDIT_CARD = 'Credit Card'
const ECHECK = 'Echeck'
const ECHECK_SAVE_PAYMENT = 'Echeck Save Payment'
const ECHECK_ROUTING_ERROR = 'Echeck Routing Error'
const ECHECK_ACCOUNT_ERROR = 'Echeck Account Error'
const CREDIT_CARD_SAVE_PAYMENT = 'Credit Card Save Payment'
const CREDIT_CARD_CANCEL = 'Credit Card Cancel'
const CREDIT_CARD_NUMBER_ERROR = 'Credit Card Number Error'
const CREDIT_CARD_EXP_DATE_ERROR = 'Credit Card Exp Date Error'
const ECHECK_CANCEL = 'Echeck Cancel'
const GET_HOMEBODY = 'Get Homebody'
const GET_A_QUOTE = 'Get A Quote'
const RI_TITLE = 'RI Title'
const MY_APARTMENT_INSURANCE = 'My Apartment Insurance'
const INSURANCE_ALERT = 'Insurance Alert'
const NO_INSURANCE_ALERT = 'No Insurance Alert'
const LIABILITY_MENU = 'Liability Menu'
const PERSONAL_CONTENTS_MENU = 'Personal Content Menu'
const DEDUCTIBLE_MENU = 'Deductible Menu'
const UPLOAD_PROOF_OF_INSURANCE = 'Upload Proof Of Insurance'
const ID_THEFT_TOOL_TIP = 'Id Theft Tool Tip'
const ADD_POLICY_EVENT = 'Add Policy'
const CLIENT_RELEASE_TRACK = 'Client Release Track'

export const events = {
  EMAIL_ENTERED,
  CUSTOMER_INFO_ENTERED,
  ENROLLMENT_CONFIRMED,
  ENROLLMENT_SUBMITTED,
  QUOTE_STARTED,
  ENROLL_BUTTON_CLICKED,
  QUOTE_VIEWED,
  PROPERTY_SELECTED,
  COVERAGE_START_DATE_SELECTED,
  ADD_ADDITIONAL_INSURED_CLICKED,
  ADD_INSURED_SAVED,
  ADD_INSURED_CANCEL,
  CHANGE_COVERAGE_SAVE,
  CHANGE_COVERAGE_CANCEL,
  CHANGE_COVERAGE_BACK,
  EASY_ENROLL_BACK,
  BACK_BROWSER,
  SELECT_PAYMENT_METHOD_CLICKED,
  ADD_INSURED,
  PAYMENT_ENTERED,
  EDIT_POLICY,
  COMPLETE_ENROLLMENT,
  TIMEOUT_TRIGGERED,
  EXISTING_EMAIL_ENTERED,
  PAGE_NOT_FOUND,
  ADD_OWN_POLICY,
  EXISTING_POLICY_ADDED,
  CREDIT_CARD,
  ECHECK,
  ECHECK_SAVE_PAYMENT,
  ECHECK_ACCOUNT_ERROR,
  ECHECK_ROUTING_ERROR,
  CREDIT_CARD_SAVE_PAYMENT,
  CREDIT_CARD_CANCEL,
  CREDIT_CARD_NUMBER_ERROR,
  CREDIT_CARD_EXP_DATE_ERROR,
  ECHECK_CANCEL,
  GET_HOMEBODY,
  GET_A_QUOTE,
  RI_TITLE,
  MY_APARTMENT_INSURANCE,
  INSURANCE_ALERT,
  NO_INSURANCE_ALERT,
  LIABILITY_MENU,
  PERSONAL_CONTENTS_MENU,
  DEDUCTIBLE_MENU,
  UPLOAD_PROOF_OF_INSURANCE,
  ID_THEFT_TOOL_TIP,
  ADD_POLICY_EVENT,
  CLIENT_RELEASE_TRACK,
}

/**
 * Amplitude write keys per environment (Tenant Portal).
 *   staging    -> Entrata - Dev (project 748065).
 *   production -> AMPLITUDE_API_KEY injected by the GitHub production build.
 * These are Amplitude *browser* write keys: each is a public,
 * write-only ingestion key that ships in the client bundle by design (it is
 * visible in the network request), so it is not a secret in the CSP sense.
 */
const AMPLITUDE_API_KEYS = {
  [ENVIRONMENTS.PRODUCTION]: process.env.AMPLITUDE_API_KEY || '',
  [ENVIRONMENTS.STAGING]: '9276472050524432793b651ac5532588',
}

// Selects the environment's key only on an enabled host.
export const getAmplitudeApiKey = options =>
  isAnalyticsEnabledHost(options)
    ? AMPLITUDE_API_KEYS[getEnvironment(options)] || ''
    : ''

let isInitialized = false

/**
 * Initializes Amplitude. Idempotent and gated on a configured API key, so it is
 * safe to call from app bootstrap.
 */
export const initialize = options => {
  if (typeof window === 'undefined' || isInitialized) return
  const apiKey = getAmplitudeApiKey(options)
  if (!apiKey) return
  init(apiKey, {
    // Emit ONLY our explicit taxonomy events: no page-view / session / element
    // autocapture and no auto page-property enrichment. Device/OS/platform
    // context (the Context plugin) is unaffected and still attached.
    autocapture: false,
  })
  isInitialized = true
}

/**
 * Tracks a Tenant Portal (PXR-Commercial) event through the shared Amplitude
 * pipe. Sets the Amplitude User ID to the passed user_id — the portal user's
 * `contactUserId`, which is deliberately NOT the `cid` (cid is the client-level
 * id and rides along as a separate shared property). Ensures the SDK is
 * initialized first. Intended to be called via the `useAmplitudeTracking` hook,
 * which supplies the shared properties.
 *
 * @param {string} eventName
 * @param {Object} [properties] - merged shared + event-specific properties
 * @param {string|number} [userId] - Amplitude User ID = the `user_id` shared
 *   property (the user's contactUserId)
 * @param {Object} [options] - test/override hook forwarded to the host gate
 *   (e.g. `{ hostname }`); production callers omit it.
 */
export const trackCommercialEvent = (
  eventName,
  properties = {},
  userId,
  options,
) => {
  if (typeof window === 'undefined' || !eventName) return
  // Lazy-init guard: initialize() is idempotent (see its `isInitialized` and
  // no-key short-circuits), so this is a no-op on the happy path where
  // client.jsx already initialized at bootstrap. It is kept as a deliberate
  // fallback for any track that runs before bootstrap completes (or if the
  // bootstrap call is ever refactored away).
  initialize(options)
  // Gate delivery explicitly rather than relying on the SDK's pre-init queue.
  if (!getAmplitudeApiKey(options)) return
  if (userId !== undefined && userId !== null) {
    setUserId(String(userId))
  }
  track(eventName, properties)
}

/**
 * Legacy Resident-Portal event bridge.
 *
 * In Tenant Portal these RP-derived events (insurance / community-feed /
 * alerts-panel) MUST NOT be forwarded to Amplitude: the TP Amplitude project
 * only receives PXR-Commercial events emitted via `trackCommercialEvent`.
 * Because the Amplitude SDK is now initialized (a single shared instance), any
 * `track()` call here would leak legacy RP events into the TP project — so this
 * is intentionally an exported no-op. It is kept (rather than deleted) so the
 * existing RP-derived imports of `sync` do not break.
 */
export const sync = () => {}
